import React, { useState } from "react";

import { Button, Icon, Modal } from "semantic-ui-react";

import CardSettingPackage, {
  CardSettingPackageProps,
} from "react-lib/apps/HISV3/HCU/CardSettingPackage";

import ModBackupReceiptTemplate from "./ModBackupReceiptTemplate";

import "./CardMeSettingPackage.scss";

const CardMeSettingPackage = (props: CardSettingPackageProps) => {
  const [openBackupReceipt, setOpenBackupReceipt] = useState(false);

  const handleClose = () => {
    props.runSequence({ sequence: "SettingPackage", action: "CLEAR" });
  };

  return (
    <div className="CardMeSettingPackage">
      {/* หัวข้อของการ์ดถูกซ่อนแล้ววาดเองที่นี่ เพื่อวางปุ่มดาวน์โหลดไว้แถวเดียวกัน (#86100) */}
      <div className="setting-package-header">
        <div className="title">ตั้งค่าสำหรับเปิดขาย Package</div>

        <Button basic color="green" onClick={() => setOpenBackupReceipt(true)}>
          <Icon name="download" />
          ดาวน์โหลด Excel ราคาแพ็กเกจ (ออกใบเสร็จแบบ Manual)
        </Button>
      </div>

      <ModBackupReceiptTemplate
        open={openBackupReceipt}
        setProp={props.setProp}
        runSequence={props.runSequence}
        buttonLoadCheck={props.buttonLoadCheck}
        onClose={() => setOpenBackupReceipt(false)}
      />

      <CardSettingPackage
        setProp={props.setProp}
        onEvent={props.onEvent}
        // seq
        runSequence={props.runSequence}
        SettingPackageSequence={props.SettingPackageSequence}
        // CommonInterface
        buttonLoadCheck={props.buttonLoadCheck}
        errorMessage={props.errorMessage}
        searchedItemListWithKey={props.searchedItemListWithKey}
        showPackageCategory
        showPackageDisplay
        hideDetail
        hideTitle
        hideSearchBoxDropdown
        filterByDivision
        // options
        masterOptions={props.masterOptions}
        masterData={props.masterData}
        languageUX={props.languageUX}
      />
      <Modal
        open={!!props.SettingPackageSequence?.showDetail}
        style={{ width: "fit-content" }}
        closeOnDimmerClick
        closeIcon
        onClose={handleClose}
      >
        <div className="CardMeSettingPackage">
          <CardSettingPackage
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            SettingPackageSequence={props.SettingPackageSequence}
            // CommonInterface
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            searchedItemListWithKey={props.searchedItemListWithKey}
            restart={false}
            showPackageCategory
            showPackageDisplay
            hideSubSearchPackage
            hideTitle
            visibleTabs={["ALL", "LAB"]}
            filterByDivision
            // options
            masterOptions={props.masterOptions}
            masterData={props.masterData}
            languageUX={props.languageUX}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CardMeSettingPackage;
